import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHiddenPlatformNotifications } from '../hooks';
import { useSelector } from 'react-redux';
import { getCountryList } from '@topconagriculture/country';
import { ActiveNotification } from './ActiveNotification';
import { getUserCompany, isPlatformNotificationLegacy } from '../utils';
export const ActiveNotificationList = ({ notifications, tenantId, config, ...platformNotificationOptions }) => {
    const { hideNotification, isNotificationHidden } = useHiddenPlatformNotifications();
    const [activeIndex, setActiveIndex] = useState(0);
    const company = useSelector(getUserCompany);
    const countries = useSelector(getCountryList);
    const getCountryByCode = (code) => countries.find((country) => country.code === code);
    const country = getCountryByCode(company === null || company === void 0 ? void 0 : company.countryId) || navigator.language.slice(-2);
    const notifiableNotifications = notifications.filter((notification) => {
        var _a, _b;
        if (isNotificationHidden(notification.id)) {
            return false;
        }
        if (isPlatformNotificationLegacy(notification)) {
            return true;
        }
        const filter = notification.filters.find((obj) => obj.tenantId === tenantId);
        if (!filter) {
            return false;
        }
        if (filter.areas || filter.countries) {
            return ((_a = filter.countries) === null || _a === void 0 ? void 0 : _a.includes(country.code)) || ((_b = filter.areas) === null || _b === void 0 ? void 0 : _b.includes(country.geoArea || ''));
        }
        else if (filter.distributors) {
            if (!company) {
                return false;
            }
            return !!filter.distributors.find((distributor) => distributor.id === company.id);
        }
        return true;
    });
    useEffect(() => {
        if (activeIndex > 0 && activeIndex >= notifiableNotifications.length) {
            setActiveIndex(0);
        }
    }, [notifiableNotifications]);
    const hasMore = notifiableNotifications.length > 1;
    const activeIndexList = useMemo(() => notifiableNotifications.map((notification) => notification.id), [notifiableNotifications]);
    const goToNext = useCallback(() => setActiveIndex((prevState) => ++prevState), [setActiveIndex]);
    return (React.createElement(ActiveNotification, { notification: notifiableNotifications[activeIndex], onClose: hideNotification, onNext: goToNext, hasMore: hasMore, config: config, activeIndexList: activeIndexList, ...platformNotificationOptions }));
};
//# sourceMappingURL=ActiveNotificationList.js.map